import { createSlice } from '@reduxjs/toolkit'
import { patientContentTexts } from 'locale/es'
import PatientContentService from 'services/PatientContentService'
import { toast } from './notificationReducer'

const initialState = { data: [], loading: false, error: null }

const patientContentSlice = createSlice({
  name: 'patientContent',
  initialState,
  reducers: {
    setPatientContent(state, action) {
      const { data } = action.payload

      return { ...state, data, loading: false, error: null }
    },
    updatePatientContent(state, action) {
      const { data } = action.payload

      const updatedParticipantContent = state.data.map((participantContent) =>
        participantContent.id !== data.id ? participantContent : data
      )

      return { ...state, data: updatedParticipantContent, loading: false, error: null }
    },
    deletePatientContent(state, action) {
      const newDataState = state.data.filter((patientContent) => patientContent.id !== action.payload)

      return { ...state, data: newDataState, loading: false, error: null }
    },
    setPatientContentLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setPatientContentError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetPatientContentState(state, action) {
      return initialState
    }
  },
})

export const { setPatientContent, updatePatientContent, deletePatientContent, setPatientContentLoading, setPatientContentError, resetPatientContentState } =
  patientContentSlice.actions

export const initializePatientContent = (patientId) => {
  return async (dispatch) => {
    try {
      dispatch(setPatientContentLoading());

      const { data } = await PatientContentService.getAll(patientId)
      dispatch(setPatientContent({ data }))
    }
    catch (error) {
      console.error(error)
      dispatch(setPatientContentError({ message: error.message, status: error.response?.status }));
      dispatch(toast(patientContentTexts.LOADING_ERROR, 'error'))
    }
  }
}

export const updatePatientContentAction = (patientContentId, fieldsToUpdate) => {
  return async (dispatch) => {
    try {
      const { data } = await PatientContentService.update(patientContentId, fieldsToUpdate)
      dispatch(updatePatientContent({ data }))
      dispatch(toast(patientContentTexts.EDITED, 'success'))
    } catch (error) {
      dispatch(setPatientContentError({ message: error.message, status: error.response?.status }));
      dispatch(toast(patientContentTexts.EDITED_ERROR, 'error'))
      console.error(error)

    }
  }
}

export const deletePatientContentAction = (id) => {
  return async (dispatch) => {
    try {
      await PatientContentService.remove(id)
      dispatch(deletePatientContent(id))
      dispatch(toast(patientContentTexts.DELETED, 'success'))
    } catch (error) {
      console.error(error)
      dispatch(setPatientContentError({ message: error.message, status: error.response?.status }));
      dispatch(toast(patientContentTexts.DELETED_ERROR, 'error'))
    }
  }
}

export default patientContentSlice.reducer